// import { axiosPrivate } from "../api/axios/axios";
// import useRefreshToken from "./useRefreshToken";
import { useEffect } from "react";
// import useAuth from "./useAuth";
import useStore from "./useStore";
import useRefreshToken from "./useRefreshToken";
import { axiosPrivate } from "../api/axios/axios";

const useAxiosPrivate = () => {
  const refresh = useRefreshToken();
  const { auth } = useStore();

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        // console.log(config, "config in request");
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${auth?.accessToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        console.log(error, "error in response");
        const prevRequest = error?.config;
        if (error?.response?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const newAccessToken = await refresh();
          prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return axiosPrivate(prevRequest);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
    // console.log(responseIntercept, "interceptor");
  }, [auth, refresh]);

  return axiosPrivate;
};
export default useAxiosPrivate;
